import React from "react";
// import NavBar from "../sections/NavBar";
// import Footer from "../sections/Footer";
import { useNavigate } from "react-router-dom";
import sideArrow from "../../images/icons/sideArrow.png";

export default function Privacy() {
  const navigate = useNavigate();

  const terms = [
    {
      title: "Information We Collect",
      list: [
        "Basic details submitted through our contact form such as your name, email address, mobile number, and service requirement.",
        "Location information only if you manually provide it in the form.",
        "Technical details like IP address, browser type, and device type collected through analytics tools.",
        "No sensitive financial or personal documents are collected or stored on this static website.",
      ],
    },

    {
      title: "How We Use Your Information",
      list: [
        "To respond to your inquiries submitted via the contact form.",
        "To provide service quotes, follow-up communication, or customer support.",
        "To improve the performance and user experience of our website.",
        "To analyze website traffic and understand user interaction patterns.",
      ],
      afterNote:
        "Your information is not used for automated decision-making or profiling.",
    },

    {
      title: "Data Security",
      content:
        "This is a static website, and we do not store user data on our servers. However, we ensure encrypted communication (HTTPS) to protect the data transmitted through the contact form.",
    },

    {
      title: "Contact Form Submissions",
      content:
        "Information submitted through our contact form is shared only with the Carzen Logistics team via email or CRM tools. We do not store or process this data on the website itself.",
    },

    {
      title: "Sharing of Information",
      list: [
        "We do not sell or rent personal information to third parties.",
        "Information may be shared with customer support tools, email services, or CRM platforms solely for responding to your inquiry.",
        "Information may be disclosed to authorities only when legally required.",
      ],
    },

    {
      title: "Third-Party Services & External Tools",
      content:
        "Our website may use third-party services such as Google Analytics, Google Maps, or email service providers. These services have their own privacy policies, and we recommend reviewing them separately.",
    },

    {
      title: "Cookies & Tracking Technologies",
      list: [
        "We use cookies to enhance website performance and improve user experience.",
        "Analytics tools may place cookies to track website activity anonymously.",
        "You can disable cookies in your browser settings, but certain features may not work properly.",
      ],
    },

    {
      title: "Your Rights",
      list: [
        "You may request the deletion of your submitted information by contacting us.",
        "You may request clarification about how your data is handled.",
        "You may opt out of receiving further communication from us.",
      ],
    },

    {
      title: "Children’s Privacy",
      content:
        "Our website and services are not intended for children under the age of 16. We do not knowingly collect information from minors.",
    },

    {
      title: "Policy Updates",
      content:
        "We may update this Privacy Policy periodically to reflect changes in services or legal requirements. Continued use of our website after updates constitutes acceptance of the revised policy.",
    },
  ];

  return (
    <>
      {/* <div className="max-w-7xl  md:mx-auto  mx-4 bg-[#FFF2E1]">
        <NavBar />
      </div> */}
      <div className="max-w-9xl mx-auto  md:pb-10">
        {/* Back Button */}

        <div className="bg-[#CCA065] md:mb-10  mb-9  text-white content-center">
          <button
            onClick={() => navigate("/")}
            className="mb-6 lg:ml-9 lg:mt-4 inline-flex items-center content-start gap-2 text-sm sm:text-base 
             text-white px-4 py-2 rounded-lg transition"
          >
            {" "}
            <span className=" lg:px-2 w-7 h-7 md:w-[30px] md:h-[30px] flex items-center justify-center bg-white rounded-full">
              <img
                src={sideArrow}
                className="w-3 h-3 object-contain"
                alt="arrow"
              />
            </span>
            {/* Back to Home */}
          </button>
          <h1 className="mx-2 text-2xl  md:text-5xl font-bold text-gray-100 ml-4 lg:ml-40">
            Privacy Policy
          </h1>
          <p className="mx-2 mt-4 mb-10 lg:mb-16 text-sm md:text-[18px] ml-4  lg:ml-40">
            Your privacy is important to us. Learn how we collect, use, and
            protect your information.
          </p>
        </div>
        <div className="max-w-5xl md:mx-auto mx-4">
          {terms.map((item, index) => (
            <div key={index} className="mb-10 ">
              <h2 className="text-xl md:text-2xl font-semibold text-[#CCA065] mb-3">
                {item.title}
              </h2>

              {item.content && (
                <p className="text-gray-600 leading-relaxed">{item.content}</p>
              )}

              {item.list && (
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  {item.list.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              )}

              {item.afterNote && (
                <p className="mt-3 text-gray-600 italic">{item.afterNote}</p>
              )}

              <div className="border-b border-gray-300 mt-6"></div>
            </div>
          ))}
          <div>
            {/* <p className="text-gray-700 leading-relaxed">
              <h1 className="text-xl md:text-2xl font-semibold text-[#CCA065] mb-3">
                Contact Us
              </h1>
              <p>
                If you have any questions regarding this Privacy Policy or our
                data practices, you can reach us at:
              </p>
              <br />
              <div className="bg-white rounded-md mx-2 px-2">
                <strong>Cargen Logistics</strong>
                <br />
                Email: <span className="">carzenlogistics@gmail.com</span>
                <br />
                Phone: <span className="">+91 8123415558</span> <br />
                Address{" "}
                <span className="">
                  {" "}
                  Near Sobha Apartments, Hosa Road, Bengaluru, Karnataka -
                  560100
                </span>
                <br />
              </div>
            </p> */}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}
